import { useHistory } from 'react-router-dom';

// Import styles
import { StepsWrapper, StepButton } from './styles';

// Import helpers
import { CONFIGURATOR_STEPS } from 'components/views/offer_configurator/helpers/steps';

type Props = {
	activeStep: number;
};

export const Steps = ({ activeStep }: Props) => {
	const history = useHistory();

	const onClick = (path: string) => history.push(path);

	return (
		<StepsWrapper>
			{CONFIGURATOR_STEPS.map((item, index) => (
				<StepButton key={item.path} isActive={index === activeStep} onClick={onClick.bind(null, item.path)} disabled={activeStep < index}>
					{index + 1}
				</StepButton>
			))}
		</StepsWrapper>
	);
};
